


$(document).ready(function() {

    /**
     * After click on the second date, prevent hover events
     * @type {boolean}
     */
    let preventHover = false;

    /**
     * Display state of the first calendar panel
     * @type {boolean}
     */
    let firstPanelActive = false;

    /**
     * Display state of the second calendar panel
     * @type {boolean}
     */
    let secondPanelActive = false;

    /**
     * When a DateTimePicker function is called, prevent on.change event to be triggered
     * @type {boolean}
     */
    let preventOnChange = false;

    /**
     * First date on the selected range
     * @type {String}
     */
    let begindate;

    /**
     * Second date on the selected range
     * @type {String}
     */
    let finishdate;

    /**
     * Contains objects of the days that are in range
     * @type {Array}
     */
    let days = [];

    /**
     * Speed value for the Slide Up/Down functions
     * @type {number}
     */
    let slideSpeed = 250;

    /**
     * An array of url elements
     * @type {string[]}
     */
    let url = window.location.href.split(".");

    /**
     * Check if the information modal about the Age is already loaded on the page
     * @type {boolean}
     */
    let loadedAge = false;

    /**
     * Check if the information modal about the Abroad is already loaded on the page
     * @type {boolean}
     */
    let loadedAbroad = false;

    /**
     * Width of the windows in pixels
     * @type {*|jQuery}
     */
    let width = $(window).width();

    /**
     * Get cookie value
     * @param cname {string} - Cookie name
     * @returns {string} - Cookie value
     */
    function getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    function findGetParameter(parameterName) {
        var result = null,
            tmp = [];
        var items = location.search.substr(1).split("&");
        for (var index = 0; index < items.length; index++) {
            tmp = items[index].split("=");
            if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        }
        return result;
    }
    
    /**
     * Set the value from calendar input to calendar selection button
     * @param calendarInputID
     */
    function setCalendarButton(calendarInputID) {
        let getDate;
        let tmp_formatDate;
        let day;
        let month;
        let dateButton;

        getDate = $('#' + calendarInputID).val();
        getDate = getDate.replace(/\//g, "-");

        tmp_formatDate = moment(getDate, 'DD-MM-YYYY');
        day = moment(tmp_formatDate).format('DD'); // e.g. 23
        month = moment(tmp_formatDate).locale(lang).format('MMMM'); // e.g. July
        month = month.charAt(0).toUpperCase() + month.slice(1); // Capitalize first letter

        dateButton = $('.' + calendarInputID);
        dateButton.find('.text').hide();
        dateButton.find('.day').html(day).show();
        dateButton.find('.month').html(month).show();
    }

    function getErrorOffHours(hours) {
        let path = location.pathname.split('/')
        let langPath = ''
        if (typeof path[1] !== 'undefined' && path[1] === getCookie('lang')) {
            langPath = '/' + path[1]   
        }
        let hostname = location.protocol + '//' + location.hostname + langPath + '/api/getErrorOffHours/?hours=' + hours;
        return $.ajax({
            url: hostname,
            type: 'get'
        });
    }
    
    function getLocationPhone(code) {
        let hostname = location.protocol + '//' + location.hostname + '/api/get_location_phone/' + code;
        return $.ajax({
            url: hostname,
            type: 'get'
        });
    }
    function checkAdvanceTime() {

        let code = $("select[name='startloc']").val()

        let startHour = $('#starthourpost').val() + ":" + $('#startminpost').val()
        let startDate = $("#startpanel").data("DateTimePicker").date(); // Moment object
        let dateStart = new Date(moment(startDate).format('Y-MM-DD') + " " + startHour)

        let endHour = $('#endhourpost').val() + ":" + $('#endminpost').val()
        let endDate = $("#endpanel").data("DateTimePicker").date(); // Moment object
        let dateEnd = new Date(moment(endDate).format('Y-MM-DD') + " " + endHour)

        let currentTime = findGetParameter('current_time')
        let currentDate = new Date()
        if (currentTime !== null) {
            let newCurrentDate = new Date().toJSON().slice(0,10).replace(/-/g,'-');
            currentDate = new Date(newCurrentDate + 'T' + currentTime)
        }
        let nextTwelveHours = new Date(currentDate.getTime())
        nextTwelveHours.setHours(nextTwelveHours.getHours() + 12)
        
        $(".advance-time-notif.during-program").css("display", "none");
        $(".advance-time-notif.outside-program").css("display", "none");
        $("input[name='notif_type']").val("")
        if (!isValidDate(dateStart) || !isValidDate(dateEnd) || code === "NO" || dateStart > dateEnd ||
            (isValidDate(dateStart) && dateStart > nextTwelveHours) || dateStart < currentDate) {
            return false
        }
        $(".advance-time-notif").css("display", "none");
        let minLimit = new Date(currentDate.getTime());
        minLimit.setHours(8)
        minLimit.setMinutes(0)
        minLimit.setSeconds(0)
        let maxLimit = new Date(currentDate.getTime());
        maxLimit.setHours(22)
        maxLimit.setMinutes(0)
        maxLimit.setSeconds(0)

        let afterThreeH = new Date(currentDate.getTime())
        afterThreeH.setHours(afterThreeH.getHours() + 3)
        if (dateStart > minLimit && dateStart < afterThreeH && dateStart < maxLimit) {
            getLocationPhone(code).done( function(data) {
                $(".advance-time-notif.during-program span").html(data)
                $(".advance-time-notif.during-program").css("display", "block");
                $("input[name='notif_type']").val("1")
            });
            return
        }
        
        // if (dateStart > maxLimit) {
        if (currentDate > maxLimit || currentDate < minLimit) {
            // Off hours
            let newMinLimit = new Date(minLimit.getTime())
            newMinLimit.setSeconds(0)
            newMinLimit.setMilliseconds(0)
            if (currentDate > maxLimit) {
                newMinLimit.setDate(newMinLimit.getDate() + 1)
            }
            if (dateStart < newMinLimit) {
                getLocationPhone(code).done( function(phone) {
                    let diff = Math.ceil(Math.abs(currentDate - newMinLimit) / 3600000);
                    getErrorOffHours(diff).done(function (hour) {
                        let errorMessage = JSON.parse(hour).message
                        $(".advance-time-notif.outside-program td.text").html(errorMessage + ' <span>' + phone + '</span>')
                        $(".advance-time-notif.outside-program").css("display", "block");
                        $("input[name='notif_type']").val("2")
                    });
                })
            }
        }
    }
    function isValidDate(d) {
        return d instanceof Date && !isNaN(d);
    }
    /**
     * Get language acronym from cookie
     * @type {string}
     */
    let lang = $('html').attr('lang');

    if($('select[name="endloc"]').val() !== "SAME") {
        $('.otherlocation').hide();
        $('.endloc').show();
    }
    //Check if the form returns an error and save the previous date selections
    if($('#feedback').length) {
        setCalendarButton("startdate");
        setCalendarButton("enddate");
    }
    $('.otherlocation input').on('change', function() {
        $('.otherlocation').hide();
        $('.endloc').show();
    });

    $('.startdate .btn-calendar').click(function () {
        let startpanel = $('#startpanel');
        let endpanel = $('#endpanel');
        let startdate = $('.startdate');
        let enddate = $('.enddate');
        preventHover = false;

        endpanel.hide();

        startdate.find('.text').show();
        startdate.find('.day').hide();
        startdate.find('.month').hide();

        enddate.find('.btn-calendar').removeClass('selected');
        $(this).addClass('selected');

        // Show/Hide panels based on their current status
        if(secondPanelActive) {
            startpanel.show();
            endpanel.hide();
            firstPanelActive = true;
        } else {
            if(firstPanelActive) {
                startpanel.slideUp(slideSpeed);
                $(this).removeClass('selected');
                firstPanelActive = false;
            } else {
                startpanel.slideDown(slideSpeed);
                firstPanelActive = true;
            }
        }
        secondPanelActive = false;
        $('.datepicker .glyphicon.glyphicon-chevron-right').replaceWith('<i class="fas fa-chevron-right" style="color:white;"></i>');
        $('.datepicker .glyphicon.glyphicon-chevron-left').replaceWith('<i class="fas fa-chevron-left" style="color:white;"></i>');
    });
    $('.enddate .btn-calendar').click(function () {

        let startpanel = $('#startpanel');
        let endpanel = $('#endpanel');
        let startdate = $('.startdate');
        let enddate = $('.enddate');
        preventHover = false;

        startpanel.hide();

        enddate.find('.text').show();
        enddate.find('.day').hide();
        enddate.find('.month').hide();

        startdate.find('.btn-calendar').removeClass('selected');
        $(this).addClass('selected');

        let normalFormat = moment(begindate, 'Y.MM.DD');

        preventOnChange = true;
        endpanel.data("DateTimePicker").date(normalFormat);
        preventOnChange = false;

        if(firstPanelActive) {
            startpanel.hide();
            endpanel.show();
            secondPanelActive = true;
        } else {
            if(secondPanelActive) {
                endpanel.slideUp(slideSpeed);
                $(this).removeClass('selected');
                secondPanelActive = false;
            } else {
                endpanel.slideDown(slideSpeed);
                secondPanelActive = true;
            }
        }
        firstPanelActive = false;
        $('.datepicker .glyphicon.glyphicon-chevron-right').replaceWith('<i class="fas fa-chevron-right" style="color:white;"></i>');
        $('.datepicker .glyphicon.glyphicon-chevron-left').replaceWith('<i class="fas fa-chevron-left" style="color:white;"></i>');
    });

    $("#startpanel").on("dp.change", function () {
        let startpanel = $('#startpanel');
        let endpanel = $('#endpanel');
        let startdate = $('.startdate');
        let enddate = $('.enddate');

        $(this).hide();
        let date = $(this).data("DateTimePicker").date(); // Moment object

        let dateFormat = moment(date).format('Y.MM.DD'); // e.g. 2014.09.23
        let day = moment(date).format('DD'); // e.g. 23
        let month = moment(date).format('MMMM'); // e.g. July
        month = month.charAt(0).toUpperCase() + month.slice(1); // Capitalize first letter
        begindate = dateFormat;
        startdate.find('.text').hide();
        startdate.find('.day').html(day).show();
        startdate.find('.month').html(month).show();

        startdate.find('.btn-calendar').removeClass('selected');
        enddate.find('.btn-calendar').addClass('selected');

        preventOnChange = true;
        endpanel.data("DateTimePicker").minDate(date); // Select a date as a minimum date to be selected
        // endpanel.data("DateTimePicker").date(date); // Select same date on endpanel
        preventOnChange = false;

        endpanel.find('tbody td[class*="active"]').addClass('first');
        endpanel.show();

        // Complete startdate input with de selected date
        let inputDate = moment(date).format('DD/MM/Y'); // e.g. 23/09/2014
        $('input[name="startdate"]').val(inputDate);

        // let startHour = $('#starthourpost').val() + ":" + $('#startminpost').val()
        // let dateStart = new Date(moment(date).format('Y-MM-DD') + " " + startHour)
        //
        // let endHour = $('#endhourpost').val() + ":" + $('#endminpost').val()
        // let endDate = $("#endpanel").data("DateTimePicker").date(); // Moment object
        // let dateEnd = new Date(moment(endDate).format('Y-MM-DD') + " " + endHour)
        checkAdvanceTime()
        // In case border is red from an warning
        $(".startdate button").css("border","1px solid #a9a9a9");

        firstPanelActive = false;
        secondPanelActive = true;
    });
    $("#endpanel").on("dp.change", function (e) {
        if(preventOnChange) {
            return false;
        }
        let date = $(this).data("DateTimePicker").date(); // Moment object
        let dateFormat = moment(date).format('Y.MM.DD'); // e.g. 2014.09.23
        let day = moment(date).format('DD'); // e.g. 23
        let month = moment(date).format('MMMM'); // e.g. July
        month = month.charAt(0).toUpperCase() + month.slice(1); // Capitalize first letter
        finishdate = dateFormat;
        $('.enddate .text').hide();
        $('.enddate .day').html(day).show();
        $('.enddate .month').html(month).show();

        $('.enddate .btn-calendar').removeClass('selected');

        // Complete enddate input with de selected date
        let inputDate = moment(date).format('DD/MM/Y'); // e.g. 23/09/2014
        $('input[name="enddate"]').val(inputDate);

        // let endHour = $('#endhourpost').val() + ":" + $('#endminpost').val()
        // let dateEnd = new Date(moment(date).format('Y-MM-DD') + " " + endHour)
        //
        // let startHour = $('#starthourpost').val() + ":" + $('#startminpost').val()
        // let startDate = $("#startpanel").data("DateTimePicker").date(); // Moment object
        // let dateStart = new Date(moment(startDate).format('Y-MM-DD') + " " + startHour)
        checkAdvanceTime()

        // In case border is red from an warning
        $(".startdate button").css("border","1px solid #a9a9a9");

        for (let i = 0; i < days.length; i ++) {
            if(i === 0) { // First element
                $('#endpanel tbody td[data-day="'+days[i]+'"]').addClass('inrange first');
            } else if(i === days.length - 1) { // Last element
                $('#endpanel tbody td[data-day="'+days[i]+'"]').addClass('inrange last');
            } else {
                $('#endpanel tbody td[data-day="'+days[i]+'"]').addClass('inrange');
            }
        }
        $(this).slideUp(slideSpeed);
        preventHover = true;
        secondPanelActive = false;
        firstPanelActive = false;
    });
    $(document).on("mouseover", "#endpanel tbody td:not(.disabled)", function (e) {
        if(preventHover) {
            return false;
        }

        let enddate = $(this).attr('data-day');
        let dateFormat = moment(enddate, 'DD.MM.Y').format('Y.MM.DD');
        finishdate = dateFormat;

        if(typeof begindate !== 'undefined') {
            $('#endpanel tbody td.inrange').removeClass('inrange');
            $('#endpanel tbody td.last').removeClass('last');
            let a = moment(begindate);
            let b = moment(finishdate);
            days = [];
            // For loop only works if the dates has format like Y/MM/DD
            for (let i = a; i.diff(b, 'days') <= 0; i.add(1, 'days')) {
                let value = i.format('DD.MM.Y');
                days.push(value);
                // Check if the element is the last one from array
                if(i.diff(b, 'days') !== 0) {
                    $('#endpanel tbody td[data-day="'+value+'"]').addClass('inrange');
                } else {
                    $('#endpanel tbody td[data-day="'+value+'"]').addClass('inrange last');
                }
            }
        }
    });
    $(document).mouseup(function(e)
    {
        let panel;
        let calendar;
        let startdate = $('.startdate');
        let enddate = $('.enddate');
        let startpanel = $('#startpanel');
        let endpanel = $('#endpanel');

        if(startpanel.is(':visible')) {
            panel = startpanel;
            calendar = startdate;
        } else if(endpanel.is(':visible')) {
            panel = endpanel;
            calendar = enddate;
        } else {
            return false;
        }

        // If the target of the click isn't the calendar buttons, panel nor a descendant of the panel
        if ((!panel.is(e.target) && panel.has(e.target).length === 0) &&
            (!startdate.find('.btn-calendar').is(e.target) && startdate.find('.btn-calendar').has(e.target).length === 0) &&
            (!enddate.find('.btn-calendar').is(e.target) && enddate.find('.btn-calendar').has(e.target).length === 0)) {

            if(calendar.find('.text').is(':visible') === true && calendar.find('.day').html().length !== 0 && calendar.find('.month').html().length !== 0) {
                calendar.find('.text').hide();
                calendar.find('.day').show();
                calendar.find('.month').show();
            }

            calendar.find('.btn-calendar').removeClass('selected');
            firstPanelActive = false;
            secondPanelActive = false;
            panel.slideUp(slideSpeed);
        }
    });


    // Temporary variable (BUG)
    // let lang = url[url.length - 1].replace('/','');

    // Initialize input with the value already selected from html
    let start = $("#starthour").val().split(":");
    $('#starthourpost').val(start[0]);
    $('#startminpost').val(start[1]);

    let end = $("#endhour").val().split(":");
    $('#endhourpost').val(end[0]);
    $('#endminpost').val(end[1]);
    // End

    //Time input
    $('#starthour').on('change', function() {
        let val = $(this).val();
        if(typeof val == "string"){
            $("#starthour").css("border","1px solid #a9a9a9");
        }

        let start = $(this).val().split(":");
        let starthour = start[0];
        let startmin = start[1];
        $('#starthourpost').val(starthour);
        $('#startminpost').val(startmin);

        checkAdvanceTime()

    });
    $('#endhour').on('change', function() {
        let val = $(this).val();
        if(typeof val == "string"){
            $("#endhour").css("border","1px solid #a9a9a9");
        }

        let start = $(this).val().split(":");
        let endhour = start[0];
        let endmin = start[1];
        $('#endhourpost').val(endhour);
        $('#endminpost').val(endmin);

        checkAdvanceTime()
    });
    // End

    // Info buttons modal
    $('.info-age').click(function(){
        if(loadedAge === false) {
            $.get( window.location.protocol + "//" + window.location.hostname + "/" + lang + "/Home/getInfoAge", function( data ) {
                $("body").append(data);

                $('#info-age-modal').modal('show');
                loadedAge = true;
            });
        }
    });
    $('.info-abroad').click(function(){
        if(loadedAbroad === false) {
            $.get( window.location.protocol + "//" + window.location.hostname + "/" + lang + "/Home/getInfoAbroad", function( data ) {
                $("body").append(data);

                $('#info-abroad-modal').modal('show');
                loadedAbroad = true;
            });
        }
    });
    // End

    // Extra locations for this languages
    if( lang == 'rs' ) {
        $('li[data-original-index="2"]:eq(0)').css('border-bottom', '4px solid #ddd');
        $('li[data-original-index="1"] > a > span').css('font-weight', 'bold');
        $('li[data-original-index="2"] > a > span').css('font-weight', 'bold');
        $('li[data-original-index="1"]').css('background-color', '#fff').css('padding', '5px 0px 5px 0px');
        $('li[data-original-index="2"]').css('background-color', '#fff').css('padding', '5px 0px 5px 0px');
    } else if( lang == 'hu' ) {
        $('li[data-original-index="1"]:eq(0)').css('border-bottom', '4px solid #ddd');
        $('li[data-original-index="1"]:eq(1)').css('border-bottom', '4px solid #ddd');
        $('li[data-original-index="1"] > a > span').css('font-weight', 'bold');
        $('li[data-original-index="1"]').css('background-color', '#fff').css('padding', '5px 0px 5px 0px');
    }
    // End
    //desktop
    // $("#form2").submit(function () {
    //     var locatieSelectata = $('[name="startloc"]:eq( 1 )').find(":selected").val();
    //     var valstart = $("#xstarthour").val()[0];
    //     var valend = $("#xendhour").val()[0];
    //     var valdatestart = $("#xstartdate").val();
    //     var valdateend = $("#xenddate").val();
    //
    //     if(locatieSelectata == 'NO'){
    //         $("#firstlocation").find("button:first").css("border-color","red");
    //         return false;
    //     }
    //     if(valdatestart == ""){
    //         $("#xstartdate").css("border","1px solid red");
    //         return false;
    //     }
    //     if(valdateend == ""){
    //         $("#xenddate").css("border","1px solid red");
    //         return false;
    //     }
    //     if(typeof valstart != "string") {
    //         $(".starthour").css("border","1px solid red");
    //         return false;
    //     }
    //     if(typeof valend != "string") {
    //         $(".endhour").css("border","1px solid red");
    //         return false;
    //     }
    // });


    $("#form").submit(function () {
        let locatieSelectata = $('[name="startloc"]').find(":selected").val();
        let valdatestart = $("input[name='startdate']").val();
        let valdateend = $("input[name='enddate']").val();
        let valstart = $("input[name='starthour']").val();
        let valend = $("input[name='endhour']").val();

        if(locatieSelectata === 'NO'){
            $('[name="startloc"]').css("border-color","red");
            $('.startloc button').css("border-color","red");

            $('html, body').animate({
                scrollTop: $('.startloc').offset().top
            }, 300);
            return false;
        }
        if(valdatestart === ""){
            $(".startdate button").css("border","1px solid red");
            $('html, body').animate({
                scrollTop: $('.startdate').offset().top
            }, 300);
            return false;
        }
        if(valdateend === ""){
            $(".enddate button").css("border","1px solid red");
            $('html, body').animate({
                scrollTop: $('.enddate').offset().top
            }, 300);
            return false;
        }
        if(valstart === "") {
            $("#starthour").css("border","1px solid red");
            $('.starttime button').css("border","1px solid red");
            $('html, body').animate({
                scrollTop: $('.starttime').offset().top
            }, 300);
            return false;
        }
        if(valend === "") {
            $("#endhour").css("border","1px solid red");
            $('.endtime button').css("border","1px solid red");
            $('html, body').animate({
                scrollTop: $('.endtime').offset().top
            }, 300);
            return false;
        }
    });

    $('[name="startloc"]').on('change', function () {
        let locatieSelectata = $(this).val();
        if(locatieSelectata !== 'NO') {
            $('[name="startloc"]').css("border-color", "#a9a9a9");
            $('[name="startloc"]').css("background-color", "white");
            $('.startloc button').css("border-color", "#a9a9a9");
        }
        checkAdvanceTime()
    });
});

$(window).resize(function() {
    let width = $(window).width();
    if(width >= 768) {
        $('#starthour').selectpicker();
        $('#endhour').selectpicker();
        $('.startloc select').selectpicker();
        $('.endloc select').selectpicker();
    } else {
        $('#starthour').selectpicker('destroy');
        $('#endhour').selectpicker('destroy');
        $('.startloc select').selectpicker('destroy');
        $('.endloc select').selectpicker('destroy');
    }
});